import mediumDirectionIconUNDEFINED from './img/medium-direction/green/undefined.png';
import mediumDirectionIconN from './img/medium-direction/green/n.png';
import mediumDirectionIconNE from './img/medium-direction/green/ne.png';
import mediumDirectionIconNW from './img/medium-direction/green/nw.png';
import mediumDirectionIconS from './img/medium-direction/green/s.png';
import mediumDirectionIconSE from './img/medium-direction/green/se.png';
import mediumDirectionIconSW from './img/medium-direction/green/sw.png';
import mediumDirectionIconW from './img/medium-direction/green/w.png';
import mediumDirectionIconE from './img/medium-direction/green/e.png';
import { MediumDirection } from "../model/Medium";

export const DEBOUNCE = 300;

export const classes = (...classNames: Array<string | undefined>) => {
    return classNames.filter(className => !!className).join(' ');
}

export const getMediumIcon = (direction: MediumDirection) => {
    const iconsMap: { [direction: string]: string } = {
        [MediumDirection.UNDEFINED]: mediumDirectionIconUNDEFINED,
        [MediumDirection.N]: mediumDirectionIconN,
        [MediumDirection.NE]: mediumDirectionIconNE,
        [MediumDirection.NW]: mediumDirectionIconNW,
        [MediumDirection.S]: mediumDirectionIconS,
        [MediumDirection.SE]: mediumDirectionIconSE,
        [MediumDirection.SW]: mediumDirectionIconSW,
        [MediumDirection.E]: mediumDirectionIconE,
        [MediumDirection.W]: mediumDirectionIconW,
    }

    return iconsMap[direction] || mediumDirectionIconUNDEFINED;
}
